import { render, staticRenderFns } from "./GridCursosNoAplicados.vue?vue&type=template&id=633e9ece&"
import script from "./GridCursosNoAplicados.vue?vue&type=script&lang=js&"
export * from "./GridCursosNoAplicados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports